import { Link } from "react-router-dom"
import { Location } from "../../Interfaces"
import { useContext } from "react"
import DataContext from "../../context/dataProvider"
import { AREA_MANAGER } from "../../utils/roles"
import LocationTitleCard from "./LocationTitleCard"

interface LocationHeaderProps {
  location: Location
  activeTab?: string
  organizationName?: string
  managementCompanyName?: string
}

export default function LocationHeader({
  location,
  activeTab = "Walk Reports",
  organizationName,
  managementCompanyName
}: LocationHeaderProps) {
  const { currentUser } = useContext(DataContext)

  return (
    <>
      <LocationTitleCard
        location={location}
        organizationName={organizationName}
        managementCompanyName={managementCompanyName}
      />

      {/* Tabs */}
      <div className="bg-white shadow-lg rounded-lg mb-4">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <Link
              to={`../locations/${location.id}`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Walk Reports"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Walk Reports
            </Link>
            <Link
              to={`../locations/${location.id}`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Employees"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Employees
            </Link>
            <Link
              to={`../locations/${location.id}`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Incidents"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Incidents
            </Link>
            <Link
              to={`../locations/${location.id}/create-walks`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Setup Walks"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Setup Walks
            </Link>
            {currentUser?.roleId && currentUser.roleId >= AREA_MANAGER && (
              <Link
                to={`../locations/update/${location.id}`}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Update Location"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
              >
                Update Location
              </Link>
            )}
          </nav>
        </div>
      </div>
    </>
  )
}
